import React from 'react';
import { Box, Typography, Avatar, Button, Divider, Tooltip } from '@mui/material';
import PersonOutlineIcon from '@mui/icons-material/PersonOutline';

function ProfileCard({profile, handleAddToList, handleCardClick, idx}) {
    // Get user info from localStorage for credit check
    const userInfo = typeof window !== 'undefined' ? localStorage.getItem('userInfo') : null;
    const user = userInfo ? JSON.parse(userInfo) : null;
    const remainingCredits = user?.remainingCredits || 0;

    return (
        // data card
        <Box
            sx={{
                width: '100%',
                p: 1,
                mb: 0.5,
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'flex-start',
                bgcolor: '#fff',
                boxShadow: 2,
                borderRadius: 1,
                pl: 1, 
                borderLeft: '3px solid #1BE885', 
            }}
            key={idx}
            onClick={() => handleCardClick(profile)}
            style={{ cursor: 'pointer' }}
        >
            {/* Profile Image */}
            <Box
                sx={{
                    minWidth: 160,
                    minHeight: 160,
                    maxWidth: 250,
                    maxHeight: 250,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    boxShadow: 1,
                    borderRadius: 20,
                    bgcolor: '#fff',
                    m: 2
                }}
            >
                {profile.profilePicture && profile.profilePicture.includes('linkedin-bug-color.png') ? (
                    <Box
                        sx={{
                            width: 150,
                            height: 150,
                            borderRadius: 20,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            bgcolor: '#f5f5f5'
                        }}
                    >
                        <PersonOutlineIcon sx={{ fontSize: 80, color: '#666' }} />
                    </Box>
                ) : (
                    <Avatar 
                        src={profile.profilePicture} 
                        alt={profile.firstName + ' ' + profile.lastName} 
                        sx={{ width: 150, height: 150, borderRadius: 20 }} 
                    />
                )}
            </Box>
            <Divider color="#000000" orientation="vertical" sx={{ pt: 1, pb: 1 }}/>
            {/* Profile Details */}
            <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', pt: 2, pl: 5 }}>
                <Typography variant="h5" sx={{ fontWeight: 700, mb: 0.5 }}>{profile.firstName} {profile.lastName}</Typography>
                {/* <Typography variant="subtitle1" sx={{ color: '#666', mb: 1 }}>snippet: {profile.snippet}</Typography> */}
                
                <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2, mb: 1 }}>
                    {profile.summary && (
                        <Typography variant="body1" sx={{ color: '#888' }}>{profile.summary}</Typography>
                    )}
                </Box>
          
                <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2, mb: 1, mt: 1 }}>
                    {profile.experience && (
                        <Typography variant="subtitle2"><b>Experience:</b> {profile.experience}</Typography>
                    )}
                    {profile.education && (
                        <Typography variant="subtitle2"><b>Education:</b> {profile.education}</Typography>
                    )}
                    {profile.location && (
                        <Typography variant="subtitle2"><b>Location:</b> {profile.location}</Typography>
                    )}
                </Box>
            </Box>

            {/* Add to List Button - Rightmost */}
            <Box sx={{ display: 'flex', alignItems: 'flex-start', minWidth: '120px', pr: 2, pt: 2 }}>
                <Tooltip title={remainingCredits === 0 ? "You used all your credits!" : "Add to List"}>
                    <Button 
                        variant="contained" 
                        // disabled={remainingCredits === 0}
                        sx={{ 
                            fontSize: '11px', 
                            padding: '6px 12px', 
                            backgroundColor: remainingCredits === 0 ? '#ccc' : '#1BE885',
                            color: '#fff'
                        }} 
                        onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation(); // Prevent event from bubbling up to the card
                            if (remainingCredits > 0) {
                                handleAddToList(profile, e);
                            }
                        }}
                    >
                        Add to List
                    </Button>
                </Tooltip>
            </Box>
        </Box>
    );
};

export default ProfileCard;